export default {
  "welcome": "BONJOUR",
  "home": "PAIEMENT",
  "application": "PAYER VOS FACTURES EN TOUTE SÉCURITÉ",
  "service": "NOUS ACCEPTONS",
  "adyenInfo": "Adyen est une société internationale de paiement qui offre aux commerçants des services en ligne pour accepter les paiements électroniques par des méthodes de paiement telles que les cartes de crédit, les paiements bancaires tels que les cartes de débit, les virements bancaires et les virements bancaires en temps réel basés sur les services bancaires en ligne. ",
  "paypalInfo": "PayPal est un service de paiement en ligne qui permet de payer des achats, de recevoir des paiements, ou d’envoyer et de recevoir de l’argent. Pour bénéficier de ces services, une personne doit créer un compte puis transmettre diverses coordonnées bancaires à PayPal, telles que le numéro de carte de paiement. ",
  "transferInfo": "Le virement bancaire consiste à virer de l’argent d’un compte bancaire vers un autre. Le compte sur lequel on prélève l’argent est débité et celui sur lequel on verse l’argent est crédité.",
  "signIn": "Connectez-vous / Inscrivez-vous",
  "continue": "Une fois vous êtes connecté, veuillez cliquer sur",
  "About us"                                                                : "À propos de nous",
  "owrApps": "Nos applications",
  "onlinePayment": "Paiement en ligne",
  "yourorder": "VOTRE COMMANDE",
  "onlineCardTitle": "PAIEMENT EN LIGNE",
  "transferCardTitle": "Virement bancaire",
  "onlinePaymentInfo": "Notre système supporte le paiement par Discover, American Express, Maestro, Diners Club, Master Card et Visa.",
  "pageNotFound": "Oups, cette page n'a pas pu être trouvée!",
  "goBackToHome": "Retournez à la page d'accueil",
  "logout": "se Déconnecter",
  "help": "Aide",
  "Communities": "Communautés",
  "campaigns": "Campagnes",
  "modifyOrder": "Modifier mon inscription",
  "webPage": "Page web",
  "previous": "Précédent",
  "creditNotes": "Notes de crédit",
  "creditNotesList": "LISTE DES NOTES DE CRÉDIT",
  "journal": "Journal",
  "supplement": "Supplément",
  "issuerInvoices": "Vos factures",
  "refundAccount": "Compte de remboursement",
  "choseIban": "Choisissez un Iban en premier",
  "addNewIban": "Ajouter un nouvel Iban",
  "refundStatus": "Statut de remboursement",
  "comment": "Commentaire",
  "refund": "Rembourser",
  "next": "Suivant",
  "refundDate": "Date de remboursement",
  "ordersHistory": "HISTORIQUE DES COMMANDES",
  "paidOrders": "Les commandes payées",
  "unpaidOrders": "Les commandes non payées",
  "street": "Rue",
  "number": "Nombre",
  "locality": "Localité",
  "postalCode": "Code Postal",
  "app": "Application",
  "invoice": "Facture",
  "docType": "Type de document",
  "purchaseOrder": "Bon de commande",
  "filter": "Filtre",
  "status": "Statut",
  "DRAFT": "BROUILLON",
  "SENT": "ENVOYÉE",
  "CREATED": "CRÉÉ",
  "language": "Langue",
  "country": "Belgique, Maroc",
  "reset": "Réinitialiser",
  "searchBySubject": "Recherche par sujet",
  "subject": "Sujet",
  "cancel": "ANNULER",
  "save": "ENREGISTRER",
  "codeOwn": "Rédigez la vôtre",
  "createdAt": "Créé le",
  "groups": "Groupes",
  "moreErrordetails": "Plus de détails",
  "sent": "Envoi",
  "confirmation": "Confirmation",
  "validationMsg": "Voulez vous continuer? Si oui cliquez sur valider",
  "enterText": "Entrez un texte ...",
  "deleteCampaignConfirm": "Voulez-vous vraiment supprimer la campagne?",
  "delete": "supprimer",
  "fromEmail": "de l'email",
  "order_details": "Détails de la commande :",
  "preVatAmount": "Montant HTVA",
  "vatAmount": "Montant TVA",
  "includedVatAmount": "Montant TVAC",
  "lines_details": "Le détail des lignes de commande",
  "description": "Description",
  "price": "Prix",
  "quantity": "Quantité",
  "paymentAccepted": "Paiement accepté",
  "thanks": "Merci",
  "loading": "Chargement ...",
  "paymentRefused": "Paiement refusé",
  "paymentPending": "Pas possible d'obtenir le statut final du paiement. Vous devez prendre d'autres mesures pour terminer le paiement.",
  "paymentCancelled": "Le paiement a été annulé avant la fin.",
  "paymentError": "Une erreur s'est produite lors du traitement du paiement.",
  "paymentRefusedApi": "Le paiement a été refusé. L'autorisation de paiement a échoué.",
  "invoiceTo": "Vous allez recevoir un email contenant votre facture vers cette boîte mail",
  "adyenErr": "Veuillez réessayer plus tard",
  "vatRate": "Taux de TVA",
  "transferReminder": "Pour obtenir la confirmation de votre inscription, vous devez réaliser votre virement bancaire avec la bonne communication structurée (VCS).  Vous pouvez toujours décider de payer en ligne, avec confirmation immédiate.",
  "fromName": "du nom",
  "return": "Retour",
  "comingSoon": "PROCHAINEMENT",
  "replyTo": "RÉPONDRE Á",
  "recipientType": "Type de destinataire",
  "typeTestEmail": "Tapez les adresses mail auquelles vous souhaitez envoyer le test",
  "warning": "warning",
  "groupsIncluded": "GROUPES INCLUS",
  "excludedGroups": "GROUPES EXCLUS",
  "selectGroups": "Sélectionner des groupes",
  "excludeGroups": "Exclure des groupes",
  "Select event"                                                            : "Sélectionnez un événement",
  "Select activities"                                                       : "Sélectionnez les activités",
  "Exclude activities"                                                      : "Exclure les activités",
  "Select status"                                                           : "Sélectionnez les statuts",
  "Exclude status"                                                          : "Exclure les statuts",
  "sendTitle": "Vous êtes sur le point d'envoyer une campagne à",
  "tested": "Testé",
  "attachments": "Pièces jointes",
  "confirm": "CONFIRMER",
  "confirmSendCampaign": "Êtes-vous sûr de vouloir envoyer cette campagne?",
  "noNotNow": "NON, PAS MAINTENANT",
  "yesSend": "OUI, ENVOYER",
  "sendTestTo": "Envoyer le test à",
  "sendTest": "ENVOYER LE TEST",
  "send": "envoyer",
  "PLAIN_TEXT": "TEXT",
  "WEB_PAGE": "PAGE WEB",
  "selectTarget": "Sélectionnez un public cible",
  "campaignInfo": "Informations sur la campagne",
  "invalidObject": "l'objet doit comporter au moins 5 caractères et pas plus de 200 caractères",
  "invalidFromName": "du nom invalide, veuillez entrer plus de 4 caractères",
  "invalidEmail": "email adresse invalide",
  "emailAdd": "Ajoutez des emails et tappez ENTER",
  "userAdd": "Ajoutez un utilisateur et tappez ENTER",
  "deleteCampaignSuccess": "Suppression réussie",
  "campaignDeleted": "La campagne a était supprimée avec succès",
  "campaignTestSent": "Un email de test a été envoyé avec succès",
  "campaignTestSuccess": "Test réussi",
  "campaignSent": "La campagne a été envoyée avec succès",
  "campaignSentSuccess": "Envoi réussi",
  "campaignAdded": "La campagne a était enregistrée avec succès",
  "addCampaignSuccess": "Ajout réussi",
  "successfulAction": "Action réussie",
  "operationCompleted": "Action réalisée avec succès",
  "errorOccured": "Une erreur est survenue, essayez plus tard.",
  "incompleteOperation": "Impossible de terminer l'opération, des données incorrectes ont été soumises",
  "invalidUrl": "Impossible de terminer l'opération, un url invalide a été soumis",
  "error": "erreur",
  "enterUrl": "Entrer l'URL",
  "search": "Recherche",
  "cardNumber": "Numéro de carte",
  "cardHolderName": "Nom du titulaire",
  "cardExpirationDate": "Date d'expiration de la carte",
  "CV": "CVC/CVV/CID",
  "rememberDetails": "Rappelez-vous ces détails",
  "cardType": "Type de carte",
  "deliveredTo": "Livré à",
  "emailsOpen": "Emails ouverts",
  "linkClicks": "Liens cliqués",
  "Bounce": "",
  "Spam": "",
  "recipientsMessage": "ce filre prend en considération la langue :",
  "pauseCampaign": "pause de la campagne empêche l'envoi <br>d'autres email jusqu'à ce qu'elle soit réactivée",
  "pauseSending": "pause l'envoi d'autre email",
  "stopCampaign": "arrêter définitivement l'envoi de la campagne",
  "resume": "reprendre",
  "register_from_email": "Cette adresse n'est pas valide pour l'envoi via Amazon, cliquez sur VALIDER pour lancer le processus d'enregistrement",
  "reply_aws_email": "Un email a été envoyé par Amazon à l'adresse email Répondez-y et rafraichissez !",
  "replyToError": "Veuillez entrer un email valide ou bien un text dans le format : nom <email@example.com>",
  "validate": "valider",
  "refresh": "rafraîchir",
  "GUEST": "INVITÉ",
  "SPEAKER": "ORATEUR",
  "CONTACT": "",
  "PROSPECT": "",
  "PARTNER": "PARTENAIRE",
  "templateChoices": "Veuillez choisir une template",
  "first name"                                                              : "prénom",
  "last name"                                                               : "nom",
  "stopCampaignConfirm": "Voulez-vous vraiment arrêter définitivement cette campagne?",
  "stop": "ARRÊTER",
  "Event": "Evénement",
  "Included activities"                                                     : "Activités incluses",
  "Excluded activities"                                                     : "Activités exclues",
  "Included status"                                                         : "Status incluses",
  "Excluded status"                                                         : "Status exclues",
  "Formulas": "Formules",
  "Slots": "",
  "Options": "",
  "All": "TOUT",
  "templates": "Modèles",
  "NEXT": "SUIVANT",
  "nothing_found": "Oops, Aucun résultat ne correspond à votre recherche",
  "yes": "oui",
  "no": "non",
  "french": "Français",
  "english": "Anglais",
  "dutch": "Néerlandais",
  "overview": "aperçu",
  "links": "liens",
  "recipients": "destinataires",
  "approvals": "approbations",
  "approval_preferences": "Les préférences d'approbation d'une campagne emailing",
  "send me"                                                                 : "m'envoyer",
  "send to approvers"                                                       : "envoyer aux approbateurs",
  "Send your campaign immediately"                                          : "Envoyez votre campagne immédiatement",
  "Schedule sending of your campaign for a specific time"                   : "Programmer l'envoi de votre campagne pour une heure précise",
  "the approvers"                                                           : "les approbateurs",
  "the test is obligatory"                                                  : "le test est obligatoir",
  "automatic sending"                                                       : "l'envoi automatique",
  "the minimum number of acceptance"                                        : "le nombre minimum d'acceptation",
  "automatic_sending_paragraph"                                             : "permettre l\’envoi automatique de la campagne lorsqu'on atteint le nombre limite sans aucun rejet",
  "test_obligatory_paragraph"                                               : "la campagne ne sera pas envoyée avant l'envoi d'un test",
  "minimum_acceptance_paragraph"                                            : "le nombre minimum de validation est requis pour l'envoi automatique",
  "no_approver_found"                                                       : "vous n'avez pas encore défini les approbateurs",
  "Add an approver"                                                         : "Ajoutez un approbateur",
  "delivery date"                                                           : "date et heure d'envoi",
  "Drag and drop some files here, or click to select files to upload."      : "Faites glisser et déposez certains fichiers ici, ou cliquez pour sélectionner les fichiers à télécharger.",
  "Attachments"                                                             : "Pièces jointes",
  "attachment"                                                              : "pièce jointe",
  "reason": "raison",
  "creditNoteRefunded"                                                      : "Note de crédit remboursée",
  "Thank you for approving this campaign"                                   : "Merci d'avoir approuvé cette campagne",
  "your acceptance is taken into consideration"                             : "votre acceptation est prise en considération",
  "please specify the reason for rejection"                                 : "merci de spécifier la raison du rejet",
  "about_us_content"                                                        : `Tamtam.pro est une suite d'outils qui permet à une communauté de communiquer, partager, organiser ou  collaborer efficacement.  La plateforme est équipée de diverses applications assemblées selon les besoins par le client.  Grace  à nos outils mutualisés, nos clients disposent des dernières technologies sans devoir en assurer le développement au profit leur core business.`,
  "No approval request is sent for this release"                            : "Aucune demande d'approbation n'est envoyé pour cette version",
  "approvers' feedback for the test version"                                : "les retours des approbateurs pour la version de test",
  "preview"                                                                 : "aperçu",
  "upload"                                                                  : "télécharger",
  "apply"                                                                   : "appliquer",
  "close"                                                                   : "fermer",
  "Once you close your changes will be lost. Do you really want to continue": "Vos modifications seront perdues. Voulez-vous vraiment continuer",
  "settings"                                                                : "Paramétres",
  "search by title"                                                         : "recherche par titre",
  "none"                                                                    : "aucun",
  "last modified on"                                                        : "dernière modification le",
  "by"                                                                      : "par",
  "replicate"                                                               : "reproduire",
  "original"                                                                : "original",
  "replication"                                                             : "réplication",
  "LEGAL_REPRESENTATIVE"                                                    : "Représentant légal",
  'OFFICIAL': 'Officiel',
  'EXTERNAL': 'Externe',
  'MANAGER': 'Manager',
  "Apply authorization to selected users"                                   : "Appliquer l'autorisation aux utilisateurs sélectionnés",
  "Apply"                                                                   : "Appliquer",
  "Add new user"                                                            : "Ajouter un nouvel utilisateur",
  "Select All"                                                              : "Tout sélectionner",
  "Deselect All"                                                            : "Désélectionner",
  "allow deletion"                                                          : "permettre la suppression",
  "allow change"                                                            : "permettre le changement",
  "allow create campaign"                                                   : "Autoriser la création de la campagne",
  "allow send campaign"                                                     : "Autoriser l'envoi de la campagne",
  "Are you sure you want to delete this template"                           : "Êtes-vous sûr de vouloir supprimer ce modèle",
  "Allow use for all users"                                                 : "Autoriser l'utilisation pour tous les utilisateurs",
  "Allow use for certain users"                                             : "Autoriser l'utilisation pour certains utilisateurs",
  "user preferences"                                                        : "les préférences utilisateurs",
  "Add an image for this template"                                          : "Ajouter une image pour ce modèle",
  "privilege"                                                               : "privilège",
  "lists"                                                                   : "listes",
  "create list"                                                             : "créer une liste",
  "search by name"                                                          : "Recherche par nom",
  "subscribers"                                                             : "abonnés",
  "mandatory list"                                                          : "liste obligatoire",
  "name"                                                                    : "nom",
  "about_payment_method"                                                    : `Cette rubrique vous permet de payer vos factures. Veuillez choisir la méthode de paiement qui vous convient, ainsi que remplir les informations nécessaires.`,
  "choice_payment_mode"                                                     : "choisir un mode de paiement",
  "bank_transfer"                                                           : "Virement",
  "paymentUpdated"                                                          : "Paiement mis à jour",
  "payOnLine"                                                               : "Payer en Ligne",
  "payTransfer"                                                             : "Payer par virement",
  "transferBank-about"                                                      : "Une fois votre commande passée, il vous est possible de payer par virement.",
  "transferBank-about-2"                                                    : "Vous trouverez ci-dessus les informations nécessaires :  IBAN, BIC et VCS (pour la communication structurée).",
  "transferBank-about-3"                                                    : "Notez qu'un virement bancaire nécessite au moins 48 heures pour que l'argent soit transféré d'un compte à un autre. Dès réception de votre paiement, votre commande sera validée et une facture vous sera envoyée à l'adresse Email :",
  "hello"                                                                   : "Bonjour",
  "badge1"                                                                  : "choisissez un mode de paiement parmis les trois modes .",
  "badge2"                                                                  : "selon le mode de paiement choisi  vous aurez un formulaire à remplir .",
  "badge3"                                                                  : "vous pouvez changer votre pack .",
  "adyen1"                                                                  : "Grâce à Adyen, vous avez une portée internationale à l'aide d'un seul système.",
  "adyen2"                                                                  : " Adyen est une solution de paiement flexible, mondiale et entièrement conforme, destinée aux places de marché.",
  "onlinePaymentDesc"                                                       : " Avec notre solution vous pouvez payer par carte Discover, American Express, Maestro, Diners Club, Master Card ou Visa.",
  "virement1"                                                               : "C'est un mode de paiement qui n'est pas en ligne.",
  "virement2"                                                               : "Dans ce cas veuillez vous rendre à la banque la plus proche pour nous verser la somme conforme à votre commande sur le compte dont le RIB est indiqué ci dessous",
  "badgeAdmin1"                                                             : "Vous devez télécharger le fichier coda envoyé par la banque.",
  "badgeAdmin2"                                                             : "choisissez un fichier coda que vous avez déjà importer dans le local.",
  "badgeAdmin3"                                                             : "cliquer sur le bouton Créer paiements pour créer les paiements associés à ce fichier coda et pour faire la correspondance entre les paiement et les commandes.",
  "titreUser"                                                               : "Liste des utilisateurs",
  "listeTransfers"                                                          : "LISTE DES VIREMENTS",
  "listeOrders"                                                             : "LISTE DES COMMANDES",
  "dropzoneText"                                                            : "Faites glisser et déposez un ou plusieurs fichier coda",
  "titreResult"                                                             : "Liste des virements importés",
  "authorizePayment"                                                        : "Méthodes de paiement",
  "prevatAmount"                                                            : "Montant après TVA",
  "organization"                                                            : "Organisation",
  "coponCode"                                                               : "Code coupon",
  "refClient"                                                               : "Référence du client",
  "amount"                                                                  : "Montant",
  "bankRef"                                                                 : "Référence de la banque",
  "operationCode"                                                           : "Code Opération",
  "extrait"                                                                 : "Extrait",
  "numOperation"                                                            : "Numéro Opération",
  "phone"                                                                   : "Téléphone",
  "createPayment"                                                           : "Créer Paiement",
  "orders"                                                                  : "COMMANDES",
  "customers"                                                               : "UTILISATEURS",
  "transfers"                                                               : "VIREMENTS BANCAIRES",
  "mapCoda"                                                                 : "RECONCILIATION",
  "codaImport"                                                              : "IMPORTATION DU CODA",
  "reconsillation-coda"                                                     : "Réconciliation Coda",
  "choice"                                                                  : "Choisir",
  "associate"                                                               : "Associer",
  "associated-status"                                                       : "Status association",
  "acheteur"                                                                : "Acheteur",
  "warning-association-button"                                              : "il faut cocher les deux cotés",
  "warning-importation-button"                                              : "il faut choisir au minimum un fichier Coda",
  "payment-app"                                                             : "Application",
  "admin-espace"                                                            : "ESPACE ADMINISTRATEUR",
  "transfer"                                                                : "Virement",
  "credit_note_refunded"                                                    : "Cette note de crédit est déja remboursée dans ce compte : ",
  "credit_note_refunded1"                                                   : "Veuillez consulter une autre note de credit",
  "iban_credit_note_saved"                                                  : "Votre Iban a bien été enregister, nous vous informons que votre rembouressement sera effectué le plus tot possible.",
  "iban_credit_note"                                                        : "Entrer votre Iban pour qu'on puisse vous rembourser sur votre compte",
  "saveIban"                                                                : "Votre Iban est enregistré avec succès",
  "not_user"                                                                : "Vous n'êtes pas l'utilisateur de cette note de crédit",
  "iban_invalid"                                                            : "L'Iban n'est pas valide",
  "bic_invalid"                                                            : "Le Bic n'est pas valide",
  "import_coda_1"                                                           : "Les codas qui avaient déjà été importés",
  "warning_search_mapping"                                                  : "Il faut cocher un virement",
  "warning_search_bankTransfer"                                             : "Il faut cocher une commande",
  "ignor"                                                                   : "Ignorer",
  "force-association"                                                       : "Forcer l'association",
  "NOT_REFUNDED"                                                            : "Non Remboursée",
  "REFUNDED"                                                                : "Remboursées",
  "to-be-refunded"                                                          : "À rembourser",
  "BANK_TRANSFER"                                                           : "Virement",
  "OGONE"                                                                   : "Ogone",
  "PAYPAL"                                                                  : "Paypal",
  "MANGO_PAY"                                                               : 'Mango Pay',
  "PAY_CONIQ"                                                              : 'Payconiq',
  "MANUAL"                                                                  : "Manuel",
  "NOT_MAPPED"                                                              : "Ignoré",
  "ATTRIBUTED"                                                              : "Associé",
  "ASSOCIATED"                                                              : "Associé",
  "NOT_ASSOCIATED"                                                          : "Non associé",
  "sucess-file"                                                             : "Fichiers codas traités avec succée",
  "operation"                                                               : "Opération",
  "related-operations"                                                      : "Opérations liées",
  "attribute"                                                               : "Attribuer",
  "manual-payment"                                                          : "Différence de paiement (paiement manuel)",
  "credit-note-number"                                                      : "Numéro  ",
  "credit-note-organization"                                                : "Organisation :",
  "credit-note-date"                                                        : "Créer le :",
  "credit-note-apply"                                                       : "Appliquer",
  "show-invoice"                                                            : "télécharger la facture en PDF",
  "ABBREVIATION_BANK_TRANSFER"                                              : "V",
  "ABBREVIATION_OGONE"                                                      : "O",
  "ABBREVIATION_PAYPAL"                                                     : "P",
  "ABBREVIATION_MANUAL"                                                     : "M",
  "invalid-coda-files"                                                      : "Fichiers Coda invalides",
  "no-data-filter-left"                                                     : "Aucun résultat pour",
  "no-data-filter-right"                                                    : "en utilisant le filtre actuel.",
  "delete-filter"                                                           : "Supprimer ce filtre.",
  "PAID"                                                                    : "Payées",
  "OVER_PAID"                                                               : "Trop Payée",
  "UNDER_PAID"                                                              : "Sous Payée",
  "NOT_PAID"                                                                : "Non Payées",
  "ORDER"                                                                   : " Commande",
  "INVOICE"                                                                 : "Facture",
  "CREDIT_NOTE"                                                             :"Note de crédit",
  "Date"                                                                    :"Date",
  "user-email"                                                              :"Email utilisateur",
  "user-phone"                                                              :"Numéro Téléphone",
  "To"                                                                      :"À",
  "Application"                                                             : "Application",
  "document-number"                                                         :"Nombre des documents selectionnées est: ",
  "document-total"                                                          : "La somme des documents est : ",
  "document-total-selected"                                                 : "La somme des documents selectionés est : ",
  "Import Coda files"                                                       :"IMPORTER FICHIERS CODA",
  "Pending"                                                                 : 'En cours',
  "Documents"                                                               : "Documents",
  "Assignments"                                                             : "Paiements",
  "PAYMENT_DIFFERENCE"                                                      : "Différence de paiement",
  "EXCHANGE_DIFFERENCE"                                                     : "Différence de change",
  "CACHE_PAYMENT"                                                           : "Paiement caisse",
  "TOO_MUCH_PAID"                                                           : "Trop Payée",
  "PAYMENT_OTHER_ACCOUNT"                                                   : "Paiement autre compte",
  "required-value"                                                          : "Ce champ est obligatoire",
  "show-order"                                                              : "télécharger la commande en PDF",
  "order-detail"                                                            : "Détail de la commande",
  "show"                                                                    : "Visualiser",
  "uen"                                                                     : "Numéro de TVA",
  "get-pdf"                                                                 :"Télecharger  le pdf",
  "get-efff"                                                                 :"Télecharger  le EFFF",
  "send-by-mail"                                                            :"Envoyer par mail",
  "redo-pdf"                                                                :"Régénérer le pdf",
  "client-data"                                                             :"Données du client",
  "not-order-user"                                                          : "Vous n'êtes pas l'utilisateur de cette Commande",
  "Sous-Type"                                                               :"Sous Type",
  "show-stats"                                                              :"Montrer les statistiques",
  "stats"                                                                   : "Statistiques",
  "EN QUELQUES CHIFFRES"                                                    : "EN QUELQUES CHIFFRES",
  "Facturation"                                                             : "Facturation",
  "CA"                                                                      : "Chiffre d'affaires",
  "payment-ogone"                                                           : "Consulter les dates et les factures payées par Ogone",
  "payment-virement"                                                        : "Consulter les dates et les factures payées par Virement",
  "invoices-not-paid"                                                       : "Factures non payées",
  "facture-a-payer"                                                         : "Factures à payer",
  'Nothing to show'                                                         : 'Aucunes notification n\'est diponible',
  "Notifications of updates"                                                : "Notifications de mises à jour",
  "Invoices"                                                                : "Factures",
  "manual-amount"                                                           : "Montant Manuel",
  "manual-comment"                                                          : "Commentaire Manuel",
  "VALID"                                                                   : "Actives",
  "CANCELED"                                                                : "Annulées",
  "MONTH"                                                                   : "Mois",
  "CHOOSE-EVENEMENT"                                                        : "Choisissez un évenement",
  'Users'                                                                   : 'Utilisateurs',
  'User'                                                                   : 'Utilisateur',
  'Organization roles': 'Rôles organization',
  'Payment roles': 'Rôles paiement',
  'roles': 'rôles',
  "ORDERS"                                                                  : "Commandes",
  "INVOICES"                                                                  : "Factures",
  "CREDIT-NOTES"                                                                  : "Notes de crédit",
  "ACCOUNTANT" : "Comptable",
  "ASSISTANT" : "Assistant",
  "AUCUN" : "Aucun",
  "ADMIN" : "Admin",
  'New user': 'Nouveau utilisateur',
  'success-save-iban-bic' : "Les données sont enregistrées avec succès",
  'assistant-title' : "« Ces données ne peuvent être modifiées que par l’Admin »",
  'configure-data' : "Configuration des données de l’organisation",
  'import-coda-test': "Génerer fichier coda test",
  'Import Coda Testing' : "Génerer coda test",
  'and': "et",
  'other user(s)' : 'autre utilisateur(s)',
  'all_event' : "Tous les événements",
  'other_year' : "autre(s) année(s)",
  'other_event' : "autre(s) événement(s)",
  'unabledCommunity': "Vous n\'avez pas les accès pour continuer avec cette communauté ! ",
  "selectCategoriesMessage": "Désélectionnez pour exclure des évenements.",
  "none-event" : "Aucun événement",
  "payer-mongo-pay" : "Payer avec Mongo Pay",
  "Payer-sans-enregistrer-la-carte" : "Payer avec une autre carte",
  "Payer-avec-cette-carte" : "Payer avec cette carte",
  "Enregistrer-et-payer-avec-une-autre-carte" : "Enregistrer ma carte",
  "ou" : "OU",
  "card-Number" : "Numéro de la carte",
  "expiration-Date" : "Date d'expiration",
  "cardNumber_invalid" : "Numéro de la carte est invalid",
  "date dexpiration_invalid" : "Date d'expiration est invalid",
  "cvv_invalid" : "CVV est invalid",
  "visualiser-document" : "Visualiser le document",
  "visualiser-vos-document" : "Visualiser vos documents",
  "visualiser-vos-paiement" : "Visualiser les paiements",
  "reconcilier-paiement" : "Reconcilier le paiement",
  "payment-ok" : "Le paiement est effectué avec succès",
  "Montant-payer" : "Montant à payer : ",
  "credit-card" : "Carte de crédit",
  "debit-card" : "Carte de débit",
  "pay": "Payer",
  "choice-methode-paiement" : "Choisissez votre méthode de paiement",
  "Payer-ici" : "Payer ici :",
  "cgu" : "Conditions générales d'utilisation",
  "order-post-traitment" : "Cette commande fait objet d'un processus de réconciliation echoué.",
  "data-organization" : "Données de l'organisation",
  "gestion-rappel" : "Gestion des rappels",
  "interval" : "Déterminez l'intervalle de temps des rappels pour chaque application.",
  "modify-emailing-all-application" : "Modifier les modéles pour toutes les applications",
  "modify-emailing--application" : "Modifier les modéles",
  "events" : "Les événements / cycles / pack",
  "default-config" : "Configuration par defaut",
  "send-last-rappel" : "Envoyer le dernier rappel",
  "send-rappel" : "envoyer rappel",
  "re-send-rappel" : "renvoyer rappel",
  "show-ebox-admin" : "Voir son E-box",
  "progress-bar-documents" : "Documents payés : ",
  "progress-bar-documents-credit-notes" : "Notes de crédit remboursées : ",
  "progress-bar-rappels" : "Rappels envoyés : ",
  "sended" : "Envoyés",
  "sende" : "À envoyer",
  "innaproprie" : "Inappropriés",
  "edit-campagne" : "Modifier la campagne",
  "send-campagne" : "Envoyer la campagne",
  "send-campagne-relance" : "Envoyer une campagne des rappels",
  "years" : "Années",
  "add-year" : "Ajouter une année",
  "apps" : "Les applications",
  "add-app" : "Ajouter une application",
  "add-event" : "Ajouter un événement / cycle / pack",
  'registering' : "Formation",
  'cycle_registering' : "Cycle",
  'packOrder' : "pack",
  "inscription-type" : "Type d'inscription",
  "add-inscription" : " Ajouter un type d'inscription",
  "send-second-rappel" : "Envoyer le rappel suivant",
  "qr-expiration" : "Le code QR de pay coniq sera expiré dans :",
  "payment-mango-pay": "Consulter les dates et les factures payées par Mango Pay",
  "payment-pay-coniq": "Consulter les dates et les factures payées par Pay Coniq",
  "BANK_TRANSFER_MANGO_PAY" : "Virement MangoPay",
  "BANK_TRANSFER_PAYCONIQ" : "Virement Payconiq",
  "DOWNLOAD_ORDER": "Télécharger la commande",
  "NEW_BANK_CARD": "Nouvelle carte bancaire",
  "YES_DELETE": "Oui, supprimer",
  "CONFIRM_DELETE_CARD": "Voulez-vous vraiment supprimer cette carte bancaire ?",
  "BANK_DETAILS": "Détails bancaires",
  "MANGOPAY_CONFIGURATION": "Configuration de Mangopay :",
  "PAYCONIQ_CONFIGURATION": "Configuration de Payconiq :",
  "TRANSFERS_CONFIGURATION": "Configuration des virements :",
  "SEND_DOCUMENT_ONLINE": "Envoyer le document via email",
  "ARTICLE_CODE": "Code de l'article",
  "REFUND_DATE_MANDATORY": "La date de remboursement est obligatoire",
  "REFUND_TYPE_MANDATORY": "Le type de remboursement est obligatoire",
  "REFUND_JUSTIFICATION_MANDATORY": "La justification du remboursement est obligatoire",
  "REGISTRATION_CANCELED": "Inscription annulée",
  "REFUND_TYPE_PLACEHOLDER": "Type de remboursement",
  "REFUND_JUSTIFICATION_PLACEHOLDER": "Justification de remboursement",
  "clientName"                                                               : "Nom du client",
  "Prix/Base" : "Prix/Base",
  "choice-client" : "Choisir un Client",
  "commission-sum" : "Somme des commissions : ",
  "ACTION_CONFIGURATION": "Configuration d'action",
  "ACTION_CONFIGURATION_SAVED": "La configuration a été bien enregistrée",
  "ACTIONS": "Actions",
  "ACTION": "Action",
  "EMAIL_TYPE": "Type d'email",
  "HOURS_NUMBER": "Nombre d'heures",
  "ACTION_CONFIGURATION_ERROR": "Veuillez sélectionner des valeurs pour tout les champs",
  "WAITING_INTERVAL": "Intervalle d'attente",
  "ACTION_DATE": "Date d'action",
  "EVENT_CYCLE": "Evénement/Cycle",
  "RAPPEL": "Rappel",
  "TITLE": "Titre",
  "PAID_REGISTRANTS": "Inscrits payants",
  "FREE_REGISTRANTS": "Inscrits gratuits",
  "TOTAL": "Total",
  "DETAILS": "Détails",
  "PAYOUT_RATE": "Taux de paiement",
  "Order": "Commande",
  "AVERAGE_PRICE": "Prix moyen par achat",
  "REGISTRATION": "Inscription",
  "TYPE": "Type",
  "FORMAT": "Format",
  "REGISTRATIONS": "Inscriptions",
  "from_time": "de",
  "to_time": "à",
  "DISPLAY_TRAININGS": "Afficher les formations du cycle",
  "CYCLE_TRAINING": "Les formations du cycle :",
  "REDUCE_CYCLE": "Réduire les formations du cycle",
  "GLOBAL": "Global",
  "ACTIVITIES": "Activités",
  "REGISTERED": "Inscrits",
  "PAYING": "Payants",
  "FREE": "Gratuits",
  "PAGE_NOT_FOUND": "Page non trouvée",
  "PAYMENT_REFUSED_MESSAGE": "Nous regrettons de ne pouvoir donner suite favorable à votre demande de paiement.",
  "RETRY_PAYMENT": "réessayer le paiement",
  "GENERAL": "Générale",
  "RETOUR": "Retour",
  "DATE_CREATION": "Date de création",
  "COMPLETE_FIELDS": "Veuillez remplir tous les champs",
  "REFUND_PAGE_HEADER": "Modifier mes données de remboursement",
  "BANK": "Banque",
  "ATTRIBUTE_WITH_VCS": "Attribuer via VCS",
  "ATTRIBUTE_WITH_VCS_MESSAGE": "Voulez-vous attribuer ce virement via VCS ?",
  "REFUND_DONE": "Le remboursement a déjà été effectué.",
  "VIEW_REFUND_DETAILS": "Visualiser les données de remboursement",
  "CA_FROM_CYCLES": "Le chiffre d'affaires induit à partir des cycles",
  "MODEL_RELANCE": "Modèles de relance",
  "MANAGEMENT_REMINDERS": "Gestion des relances",
  "REMINDER_SUBTITLE": "Déterminez l'intervalle de temps des relances pour chaque application.",
  "ORGANIZATION_DATA": "Données de l'organisation",
  "VIREMENT": "Virements",
  "EMAIL_CONFIGURATION": "Configurer les e-mails",
  "MODEL_RAPPEL": "Modèles de rappel",
  "SELECT_ALL": "Sélectionner tout",
  "DESELECT_ALL": "Désélectionner tout",
  "PERSONS": "Personnes",
  "first-payment" : "1er paiement",
  "date-first-payment" : "Date du 1er paiement",
  "second-payment" : "2ème paiement",
  "date-second-payment" : "Date du 2ème paiement",
  "payment-account" : "Compte du paiement",
  "double-payment" : "Commandes doublement payées",
  "MANGO_REFUND_CONFIRM_TITLE" : "Voulez-vous vraiment faire un remboursement avec Mango pay ?",
  "REFUND_WITH_MANGO_PAY" : "Rembourser avec Mango Pay",
  "ADMINISTRATION": "Administration",
  "FEES_CONFIGURATION": "Configuration des commissions",
  "CREDIT_CARD_CONFIGURATION": "Configuration des cartes de crédit",
  "DEBIT_CARD_CONFIGURATION": "Configuration des cartes de débit",
  "FEES_SECTION_SUBTITLE": "Déterminez les commissions fixes et variables pour chaque organization",
  "FIX_FEE": "Commission fixe",
  "VARIABLE_FEE": "Commission variable",
  "MANGO_FEES": "Commissions Mango Pay",
  "event-list" : "Liste des événements à venir",
  "SELECT_REFUNDED_ORDERS" : "Veuillez sélectionner les commandes que vous avez remboursées par virement bancaire :",
  "CONFIRMATION_MESSAGE" : "Voulez-vous vraiment faire cette action ?",
  "REFUNDED_WITH_BANK_TRANSFER" : "Remboursé par virement",
  "FEES_PER_TRANSACTION" : "Commission par transaction",
  "AMOUNT_PER_TRANSACTION" : "Montant de transaction",
  "refund-payment" : "Remboursement",
  "creditor" : "opérateur",
  "payment" : "Paiement",
  "detail-payment-refund" : "Détail des paiements et des remboursements",
  "ORDER_LINES": "Lignes de la commande",
  "INVOICE_LINES": "Lignes de la facture",
  "CREDIT_NOTE_LINES": "Lignes de la note de crédit",
  "ACTIVATED" : "Activé",
  "DEACTIVATED" : "Désactivé",
  'CREDIT_NOTE_PARTIAL' : 'Note de crédit partielle',
  'CREDIT_NOTE_CONFIRM_TITLE' : 'Voulez-vous vraiment créer une note de crédit pour cette facture ?',
  'CREDIT_NOTE_CREATED_MESSAGE' : 'Une note de crédit a déjà été créée pour cette facture',
  'PARTIAL_CREDIT_NOTE_CREATED_MESSAGE' : 'Une note de crédit partielle a déjà été créée pour cette facture avec une somme de ',
  'PARTIAL_CREDIT_NOTE_CREATED_PLURAL_MESSAGE' : 'Des notes de crédit partielles ont déjà été créées pour cette facture avec une somme de ',
  'FEED_MANGO_WALLET' : 'Alimenter votre wallet',
  'ENTER_AMOUNT_FOR_MANGO_WALLET' : 'Veuillez saisir le montant avec lequel vous voulez alimenter votre wallet : ',
  'MANGO_WALLET_BALANCE' : 'Le solde de votre wallet est : ',
  'USE_THIS_CARD' : 'Utiliser cette carte',
  'FEED_MANGO_WALLET_QUESTION' : 'Voulez-vous alimenter votre wallet ?',
  'REFUND_SUCCEEDED' : 'Le remboursement a été fait  avec succès',
  'REFUND_FAILED' : 'Le remboursement a échoué à cause du manque de solde.',
  'CREATE_PARTIAL_CREDIT_NOTE_SUM_ERROR' : 'La somme des montants de notes de crédit dépasse le montant total de la facture',
  'PAYOUT_SUM_ERROR' : 'Le montant  est plus grand à ce  que vous avez sur votre wallet',
  'ENTER_PAYOUT_AMOUNT_FOR_MANGO' : 'Veuillez saisir le montant que vous voulez transférer à votre compte banquaire ',
  'payout' : 'Faire un payout',
  'CREATE_CREDIT_NOTE' : 'Créer une note de crédit',
  'PRODUCT_GROUP' : 'Groupe de produit',
  'ADD_LINE' : 'Ajouter une ligne',
  'EXCLUDING_VAT_TOTAL' : 'Total HTVA',
  'INCLUDING_VAT_TOTAL' : 'Total TVAC',
  'CREDIT_NOTE_AMOUNT_ERROR' : 'Le montant total de la note de crédit ne peut pas être supérieur à celui de la facture.',
  'CANCEL_REGISTRATION_1' : 'Annuler l’inscription de ',
  'CANCEL_REGISTRATION_2' : ' liée à cette facture',
  'not_refund_credit_note' : 'Notes de crédit non remboursées',
  'dashboard' : 'Les outils du tableau de bord',
  'import-coda-via-email' : 'Importation Coda via email',
  'user-name-invalid' : 'Adresse Email non valide',
  'password-invalid' : 'Le mot de Pass est obligatoire',
  'port-invalid' : 'Le port est obligatoire',
  'password' : 'Mot de Passe',
  'mail-box-invalid' : 'Le serveur imap est obligatoire',
  'test-connection' : 'Tester la connexion',
  'configure-imap' : 'Configuration de la connexion IMAP',
  'connection-success' : "La connexion est établie",
  'config-imap' : "Configuration d'Imap",
  'server-imap' : "Serveur imap",
  'from-email' : "Importer seulement les coda qui proviennent de :",
  'user-name' : "Email source",
  'REGISTRATIONS_TOTAL_NUMBER' : "Nombre total des inscriptions effectuées",
  "TRAININGS" : "formations",
  "CYCLES" : "cycles",
  "SEASONS" : "saisons",
  "CONGRESS" : "congrès",
  "CYCLES_ESSENTIAL" : "cycles essentiels",
  "DAILY" : "Journalier",
  "WEEKLY" : "Hebdomadaire",
  "MONTHLY" : "Mensuel",
  "YEARLY" : "Annuel",
  "RETRY" : "Réessayer",
  "ERROR_OCCURED" : "Une erreur est survenue. Veuillez réessayer !",
  "Jan" : "Jan",
  "Fév" : "Fév",
  "Mar" : "Mar",
  "Avr" : "Avr",
  "Mai" : "Mai",
  "Jui" : "Jui",
  "Jul" : "Jul",
  "Aoû" : "Aoû",
  "Sep" : "Sep",
  "Oct" : "Oct",
  "Nov" : "Nov",
  "Déc" : "Déc",
  "NO_REGISTRATIONS" : "Il n'y a pas d'inscriptions dans la période sélectionnée.",
  'HTVA' : 'HTVA',
  'TVAC' : 'TVAC',
  'TVA' : 'TVA',
  'FACTURATIONS' : 'Facturations',
  'INDIVIDUAL_FORMULAS' : 'Formules individuelles',
  'COMPANY_PACKS' : 'Packs entreprise',
  "GUESTS": "Invités",
  "PAID_FREE_PACK_REGISTRANTS": "Inscrits payants + Inscrits gratuits + Inscrits via les packs",
  "LAST_CACHE_UPDATE": "Dernière mise à jour des données : ",
  "NOW": "maintenant",
  "DOWNLOAD_DOCUMENTS_IN_XML_FORMAT": "Télécharger les documents sous format xml",
  "SUBSCRIPTIONS_PAGE_TITLE": "Abonnements",
  "SUBSCRIPTIONS_PAGE_SUBTITLE": "Gérer vos abonnements",
  "SUBSCRIPTION_CANCELLED": "Interrompu",
  "SUBSCRIPTION_STOPPED": "Arrêté",
  "SUBSCRIPTION_FAILED": "Échoué",
  "FREQUENCY": "Fréquence",
  "SUBSCRIPTION_LAST_PAYMENT": "Dernier paiement",
  "NO_SUBSCRIPTION_FOUND": "Vous n'avez aucun abonnement",
  "SUBSCRIPTION_NEXT_DEBIT_INFO": "Le prochain prélèvement est pour le ",
  "SUBSCRIPTION_FAILED_DEBIT_INFO": "Échec de prélèvement, veuillez voir l'historique de l'abonnement pour résoudre le problème",
  "SUBSCRIPTION_ENDED_INFO": "Votre abonnement a été résilié. (échec de prélèvement)",
  "SUBSCRIPTION_CANCELLED_INFO": "Votre abonnement est interrompu. Celui prendra effectivement fin le ",
  "SUBSCRIPTION": "Abonnement",
  "CHANGE_MY_CARD": "Changer ma carte",
  "CANCEL_SUBSCRIPTION": "Annuler mon abonnement",
  "BILLING_DATA": "Données de facturation",
  "CANCEL_SUBSCRIPTION_TITLE": "Changer la carte liée à l'abonnement",
  "CANCEL_SUBSCRIPTION_CONFIRMATION": "Voulez-vous vraiment annuler votre abonnement ?",
  "CARD_USED_FOR_SUBSCRIPTION": "La carte utilisée liée à cette abonnement est ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_1": "Pour vérifier la nouvelle carte, vous serez débité de ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_2": "Un remboursement se fera par la suite.",
  "NEW_CARD": "Nouvelle carte bancaire",
  "DOWNLOAD_INVOICE": "Télécharger la facture",
  "DOWNLOAD_CREDIT_NOTE": "Télécharger la note de crédit",
  "SUBSCRIPTION_CANCELLED_LOG": "Vous avez annulé votre abonnement",
  "CIT_SUCCEEDED": "Paiement d'initialisation fait avec succès",
  "MIT_SUCCEEDED": "Prélèvement fait avec succès",
  "MIT_FAILED": "Prélèvement échoué",
  "MIT_FAILED_AUTHENTICATION_NEEDED": "Prélèvement échoué: Demande d'authentification 3DS par la banque",
  "MIT_FAILED_INACTIVE_CARD": "Prélèvement échoué: Carte inactive",
  "MID_CIT_SUCCEEDED": "Paiement fait avec succès",
  "MID_CIT_FAILED": "Paiement échoué",
  "CARD_CHANGED": "La carte liée à votre abonnement a été changée",
  "PAYMENT_FAILED": "Échec du paiement de ",
  "CARD_ACTIVATED": "Carte active: paiement de ",
  "MID_CIT_REFUND_SUCCEEDED": "Le remboursement du montant d'activation de la carte est fait avec succès",
  "MID_CIT_REFUND_FAILED": "Le remboursement du montant d'activation de la carte a échoué",
  "SUCCESS": "Succès",
  "SUBSCRIPTION_HISTORY": "Historique de l' abonnement :",
  "CARD_IN_USE": "En cours d'utilisation",
  "SUBSCRIPTIONS_SUPPORTED_CARDS_INFO": "Les paiements récurrents par carte sont uniquement disponibles avec CB/Visa/Mastercard. Les cartes suivantes ne sont pas supportées : Amex, Maestro, et BCMC.",
  "YES_CANCEL": "Oui, annuler",
  "FREE_TRIAL_STARTED": "Début de votre période d'essai gratuite",
  "FREE_TRIAL": "Essai gratuit",
  "FREE_TRIAL_MONTH": " pendant vos 30 premiers jours.",
  "WE_SEND": "Nous vous enverrons ",
  "BILLING_EMAIL": "un e-mail de facturation pour chaque prélèvement fait.",
  "NEXT_DEBIT": "Prochain prélèvement mensuel est pour le ",
  "WITHOUT_COMMITMENT": "Sans engagement.",
  "SUBSCRIPTION_CAN_BE_CANCELLED": " Abonnement annulable en ligne à tout moment.",
  "DEFINE_CARD": "Définissez votre carte de paiement :",
  "new_client" : "Nouveau Client",
  "client_state" : "Etat du client",
  "last_invoice" : "Dernière facture",
  "ftp_config" : "Configuration du FTP",
  "DOWNLOAD_DOCUMENTS_FTP" : "Exporter les documents en FTP serveur",
  "user_name" : "Nom d'utilisateur",
  "host_name" : "Nom d'hôte",
  "protocol" : "Protocole",
  "OFFER_WITHOUT_INVOICE": "Offrir (sans facture)",
  "FORCE_WITH_INVOICE": "Forcer (avec facture)",
  "REGISTRATION_WAS_OFFERED": "L'inscription a été forcée. (offerte)",
  "REGISTRATION_WAS_FORCED": "L'inscription a été forcée. (en attente de paiement)",
  "FORCE_REGISTRATION": "Forcer l'inscription",
  "TEL": "Tél.",
  "reminder_sent" : "Ne pas envoyer les Rappels",
  "PREVIOUS_INVOICE" : "Facture précédente",
  "FILES_SUCCESSFULLY_IMPORTED": "Les fichiers ont été importés avec succès",
  "CONFIGURE_MODELS": "Configurer les modèles",
  "IMPORT": "Importer",
  "IMPORT_CODAS_VIA_DROPBOX": "Importer les codas via Dropbox",
  "CONFIGURE_DROPBOX": "Configurer Dropbox",
  "CONNECT_TO_DROPBOX": "Se connecter à Dropbox",
  "FOLDER_NOT_FOUND": "Dossier introuvable",
  "DROPBOX_FOLDER": "Dossier Dropbox",
  "invalid-uen" : "Le numéro TVA est invalide",
  "IMPORT_NOW": "Importer maintenant",
  "CODA_IMPORT_COMMAND_STARTED": "La commande d'import des fichiers codas a été lancée. Le contact de l'organissation recevra un email dès que l'import est terminé.",
  "CONFIGURED_FOLDER": "Le dossier configuré est : ",
  "DROPBOX_FOLDER_NOT_CONFIGURED": "Le dossier Dropbox n'a pas été configuré.",
  "SUBSCRIPTION_UPGRADED": "Vous avez changé la formule de votre abonnement",
  "CHOOSE_WALLET_FEEDING_MODE": "Choisissez le mode d'alimentation de votre wallet",
  "SEE_BANK_TRANSFERS": "Voir les virements bancaires",
  "BANK_CARD": "Carte bancaire",
  "ENTER_TAG": "Veuillez saisir un tag pour identifier le virement bancaire",
  "PAYMENT_CREATED": "Le paiement a été créé mais n'a pas encore été approuvé et traité.",
  "PLEASE_MAKE_TRANSFER": "Veuillez effectuer un transfert de {amount} et vérifier plus tard.",
  "WIRE_REFERENCE": "Référence du virement bancaire",
  "ADDRESS": "Addresse",
  "CITY": "Ville",
  "COUNTRY": "Pays",
  "CREATED_BANKWIRES": "Les virements bancaires créés",
  "VIEW_SUBSCRIPTION": "Visualiser l'abonnement",
  "dropbox_count_down" : "Le prochain import automatique sera dans :",
  "missing_coda_info" : "Attention, il y a des fichiers Codas manquants , pour plus de détails veuillez consulter ce ",
  "link" : "lien",
  "previous_date" : "Date du fichier Coda précédent",
  "next_date" : "Date du fichier Coda suivant",
  "account" : "Compte de l'organisation",
  "missing_coda_list" : "Liste des fichiers Codas manquants",
  "balance" : "Le solde de la date  : ",
  "is" : " est : ",
  "autorize_balance" : "Autoriser l'affichage du solde",
  "balance_privilege" : "Privilèges du solde",
  "total_balance" : "Le solde total ",
  "LAST_REMINDER": "Dernier rappel",
  "DOCUMENTS": "Les documents",
  "CAMPAIGNS": "Les campagnes",
  "NUMBER" : "Numéro",
  "JANUARY": "Janvier",
  "FEBRUARY": "Février",
  "MARCH": "Mars",
  "APRIL": "Avril",
  "MAY": "Mai",
  "JUNE": "Juin",
  "JULY": "Juillet",
  "AUGUST": "Août",
  "SEPTEMBER": "Septembre",
  "OCTOBER": "Octobre",
  "NOVEMBER": "Novembre",
  "DECEMBER": "Décembre",
  "START_MONTH": "Mois de début :",
  "END_MONTH": "Mois de fin :",
  "COMPARE_WITH_ANOTHER_YEAR": "Comparer avec une autre année",
  "REDUCE": "Réduire",
  "CA_TOTAL_NUMBER" : "Somme totale du chiffre d'affaire HTVA",
  "REGISTRATIONS_COMPARE_STATS": "Comparaison du nombre total des inscriptions effectuées",
  "CA_COMPARE_STATS": "Comparaison de la somme totale du chiffre d'affaire HTVA",
  "NO_CA" : "Il n'y a pas de chiffre d'affaires HTVA réalisé dans la période sélectionnée.",
  "MANAGE_MY_TURNOVER" : "Gérer mon chiffre d'affaires",
  "ALL" : "TOUS",
  "ANNUAL_TARGET" : "Objectif annuel",
  "ANNUAL_TARGET_TEXT" : "Établissez des objectifs mesurables et réalisables pour vous assurer que vous êtes sur la bonne voie.",
  "REGISTRANTS_TOTAL_NUMBER" : "Nombre total d'inscrits payants",
  "PRICE_PER_UNIT" : "Prix par unité",
  "TOTAL_BUDGET" : "Budget total",
  "COMPARE_TO_PREVIOUS_YEAR" : "que l'année précédente",
  "COMPARE_PLUS" : "de plus",
  "COMPARE_MINUS" : "de moins",
  "CURRENT_BUDGET_RESULT" : "Résultat du budget courant ",
  "TOTAL_REALIZED" : "Total réalisé",
  "ANNUAL_ADJUSTMENT_RESULT" : "Résultat d’ajustement annuel",
  "TOTAL_ADJUSTMENT" : "Total ajustement",
  "FROM" : "du",
  "TO" : "au",
  "COMPARISON_CA_TB" : "Comparaison du chiffre d’affaire réalisé  avec le budget objectif",
  "COMPARISON_ADJUSTMENT_TB" : "Comparaison de l’ajustement annuel avec le budget objectif",
  "FOLLOW_UP" : "Follow-Up",
  "NO_ANALYSIS" : "Aucune analyse n'a été générée",
  "FOLLOW_UP_TXT1" : "Prenez le temps de configurer soigneusement votre budget objectif {year} avant de générer tout follow-up.",
  "FOLLOW_UP_TXT2" : "Attention ! Le budget {year} ne pourra plus être modifié après la génération du follow-up.",
  "GENERATE_FOLLOW_UP" : "GÉNÉRER LE FOLLOW-UP",
  "TARGET_BUDGET" : "Budget Objectif",
  "REALIZED_BUDGET" : "Budget Réalisé",
  "INCOME" : "Revenu",
  "REALIZED" : "Réalisé",
  "ADJUSTMENT" : "Ajustement",
  "NO_CONFIG_DONE" : "Aucune configuration n'a été réalisée",
  "CHANGE_FILTER_WITHOUT_SAVING" : " Vous risquez de perdre votre configuration non enregistrée, voulez-vous continuer ?",
  "reminders" : "Rappels",
  "revivals" : "Relances",
  "QUIT" : "Quitter",
  "import_manuel" : "Importer Manuellement",
  "import_automatic" : "Importer Automatiquement",
  "DELETE_CONFIGURATION" : "Supprimer la configuration",
  "DELETE_CONFIGURATION_QUESTION" : "Voulez-vous vraiment supprimer cette configuration ?",
  "RESUME_SUBSCRIPTION" : "reprendre mon abonnement ",
  "CANCEL_DOCUMENT" : "Annuler la commande",
  "ORDER_CANCELLATION_MESSAGE" : "la commande a été annulée",
  "ORDER_CANCELLATION_CONFIRM" : "Voulez-vous annuler cette commande ?",
  "IS_CANCELED" : "Annulée",
  "UPDATE_CONFIGURATION_QUESTION" : "Voulez-vous vraiment modifier cette configuration ?",
  "EDIT" : "modifier",
  "DOWNLOAD_SEPA" : "Télécharger le fichier SEPA",
  "adress_line2" : "Adresse 2",
  "order_number" : "Vos Références",
  "another_infos" : "Voir plus d'informations",
  "SUBSCRIBER": "abonné",
  "SUBSCRIBERS": "abonnés",
  "RECURRENCE_COEFF" : "Le coefficient de récurrence",
  "NO_RECURRENCE_COEFF_FOR_THIS_YEAR" : "Pas de coefficient de récurrence cette année puisque c'est la première année.",
  "NEW_REGISTRANTS_TOTAL_NUMBER" : "Nombre total des nouveaux inscrits payants",
  "NEW_REGISTRANTS" : "Nouveaux inscrits",
  "FORMER_REGISTRANTS" : "Anciens inscrits",
  "TOTAL_REGISTRED" : "Total inscrits",
  "NUMBER_OF_SAMPLES" : "Nombre de prélèvements",
  "MONTHLY_PREMIUM" : "Premiums mensuels",
  "YEARLY_PREMIUM" : "Premiums annuels",
  "DOCUMENT_DOWNLOADED" : "Le document a été téléchargé",
  "COMPARE": "Comparer",
  "Cotisation" : "Cotisation",
  "CA": "Chiffre d'affaires",
  "Type cotisations" : "Type de cotisation",
  "Statutaire" : "Statutaire",
  "Fiduciaire" : "Fiduciaire",
};



// WEBPACK FOOTER //
// ./app/i18n/fr.js